import get from 'lodash/get'

import { logSearchError } from '../../../util/clientLogger'
import { getFlexDates } from '../../../services/flexDates/flexDatesApi'
import {
  _shouldCallElasticSearch,
  _handleSOPQElasticResponse,
  generateFlexDatesQuery,
} from '../helpers'

import { setExdFlexDates } from '../flexDatesActionCreators'
import { calculateAdvancePurchaseWindow } from '../../../util/calculate-advance-purchase-window'

export function fetchExdFlexDates(requestObj, tripType = 'RT') {
  return dispatch => {
    // requestObj = PCLN Search Request
    const departDate = get(requestObj, 'slices[0].travelDate')
    const apWindow = departDate && calculateAdvancePurchaseWindow(departDate)
    const isRT = tripType === 'RT'

    if (_shouldCallElasticSearch(apWindow, isRT)) {
      const sopqRangePlusMinus = 7
      const {
        query: exdQuery,
        passengerUrl: exdPassengerUrl,
      } = generateFlexDatesQuery({
        requestObj,
        tripType,
        rangePlusMinus: sopqRangePlusMinus,
      })

      const sopqQuery = exdQuery
      const sopqPassengerUrl = exdPassengerUrl

      sopqQuery.sopq = true
      getFlexDates({ request: sopqQuery, tripType })
        .then(res => {
          const response = _handleSOPQElasticResponse(
            res,
            sopqQuery.trips,
            sopqPassengerUrl,
            requestObj
          )
          dispatch(setExdFlexDates(response))
        })
        .catch(err => {
          logSearchError('Flex Dates Express Deal Error response', err)
        })
    }
  }
}
